import { Box, Button, TextField, IconButton, InputAdornment } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { PostDatosProductosTejidos } from "../../services/productosTejidos.services";
import ModalCharge from "../../modal/modalCharge";
import MenuItem from '@mui/material/MenuItem';
import secureStorage from "../../utils/secureStorage";




// const SOCKET_URL = 'http://localhost:5004/'; // URL del servidor Socket.IO
// const socket = io(SOCKET_URL, {
//   withCredentials: true,
//   transports: ["websocket", "polling"],
//   query: {
//     token: secureStorage.getItem("authToken"), // Pasar el token al conectarse
//   },
// });

const ProductosTejidos = () => {
  const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [tipo, setTipo] = useState("");
  const [descuento, setDescuento] = useState("");
  

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const USER = secureStorage.getItem('id');

    const { cod, descripcion, alto, largo, descuento, tipo, id_usuario, precio } = values;

    const valuesToSend = {
        
        cod,
        descripcion,
        alto: alto,
        largo: largo,
        descuento: parseInt(descuento),
        clase: tipo,
        id_usuario: parseInt(USER),
        precio: parseInt(precio),
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));

      const response = await PostDatosProductosTejidos(valuesToSend);
      setRegistrationSuccess(true);
      resetForm();
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key === "F9" ||
        (event.key === "Tab" && document.activeElement.name === "id_level")
      ) {
        // setIsModalLevelOpen(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Box m="20px">
      <Header title="Registro Productos" subtitle="Registro Productos/Tejidos" />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          cod: "",
          descripcion: "",
          alto:"",
          largo: "",
          descuento:"",
          tipo:"",
          precio:"",
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Código"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.cod || ""}
                name="cod"
                error={!!touched.cod && !!errors.cod}
                helperText={touched.cod && errors.cod}
                sx={{ gridColumn: "span 2" }}

              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Producto"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.descripcion || ""}
                name="descripcion"
                error={!!touched.descripcion && !!errors.descripcion}
                helperText={touched.descripcion && errors.descripcion}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Alto"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.alto || ""}
                name="alto"
                error={!!touched.alto && !!errors.alto}
                helperText={touched.alto && errors.alto}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Largo"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.largo || ""}
                name="largo"
                error={!!touched.largo && !!errors.largo}
                helperText={touched.largo && errors.largo}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Descuento"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.descuento || ""}
                name="descuento"
                error={!!touched.descuento && !!errors.descuento}
                helperText={touched.descuento && errors.descuento}
                sx={{ gridColumn: "span 2" }}
                disabled
              />
              <TextField
                select
                fullWidth
                variant="filled"
                label="Tipo"
                name="tipo"
                value={values.tipo}
                onChange={(e) => {
                  const selectedTipo = e.target.value;
                  setFieldValue("tipo", selectedTipo);
                  if (selectedTipo === "grande") {
                    setFieldValue("descuento", 40);
                  } else if (selectedTipo === "pequeña") {
                    setFieldValue("descuento", 0);
                  } else {
                    setFieldValue("descuento", "");
                  }
                }}
                onBlur={handleBlur}
                error={!!touched.tipo && !!errors.tipo}
                helperText={touched.tipo && errors.tipo}
                sx={{ gridColumn: "span 2" }}
              >
                <MenuItem value="grande">Grande</MenuItem>
                <MenuItem value="pequeña">Pequeño</MenuItem>
              </TextField>

              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Precio"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.precio || ""}
                name="precio"
                error={!!touched.precio && !!errors.precio}
                helperText={touched.precio && errors.precio}
                sx={{ gridColumn: "span 2" }}
              />
              {/* Otros campos */}
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" sx={{
                  backgroundColor: "rgb(206, 220, 0)",
                  border: "none",
                  color: "black",
                  height: "7vh",
                  width: "10vw",
                  borderRadius: "20px",
                  cursor: "pointer",
                  marginTop: "0vw",

                  "&:hover": { backgroundColor: "#bac609" },
                }} variant="contained">
                Registrar Tejido
              </Button>
            </Box>
            <ModalCharge isLoading={isLoading} />
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  cod: yup.string().required("Código del producto requerido"),
  descripcion: yup.string().required("Descripción del producto requerido"),
  alto: yup
    .number()
    .typeError("Alto debe ser un número")
    .required("Alto es requerido")
    .positive("Alto debe ser positivo"),
  largo: yup
    .number()
    .typeError("Largo debe ser un número")
    .required("Largo es requerido")
    .positive("Largo debe ser positivo"),
    descuento: yup
    .number()
    .typeError("Descuento debe ser un número")
    .required("Descuento es requerido")
    .min(0, "Descuento no puede ser negativo")
    .max(100, "Descuento no puede ser mayor a 100"),
  
    tipo: yup.string().required("Tipo de tejido requerido"),
    precio: yup
    .number()
    .typeError("El precio debe ser un número")
    .required("El precio es requerido")
    .positive("El precio debe ser positivo"),
});

export default ProductosTejidos;